import { useRef, useState } from "react";
import { ChevronsLeftRight } from "lucide-react";

export function CompareSlider({ beforeSrc, afterSrc, alt, idx = 0 }) {
  const ref = useRef(null);
  const dragging = useRef(false);
  const [pos, setPos] = useState(50);
  const [touched, setTouched] = useState(false);

  const move = (clientX) => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    setPos(Math.min(98, Math.max(2, ((clientX - r.left) / r.width) * 100)));
  };

  return (
    <div
      ref={ref}
      data-testid={`compare-slider-${idx}`}
      className="relative aspect-[4/3] overflow-hidden bg-[#2C3539] select-none touch-none cursor-ew-resize"
      onPointerDown={(e) => { dragging.current = true; setTouched(true); e.currentTarget.setPointerCapture(e.pointerId); move(e.clientX); }}
      onPointerMove={(e) => { if (dragging.current) move(e.clientX); }}
      onPointerUp={() => { dragging.current = false; }}
      onPointerCancel={() => { dragging.current = false; }}
    >
      <img src={afterSrc} alt={`${alt} — after`} className="absolute inset-0 w-full h-full object-cover" draggable={false} loading="lazy" />
      <img src={beforeSrc} alt={`${alt} — before`} className="absolute inset-0 w-full h-full object-cover" draggable={false} loading="lazy" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }} />

      <span className="absolute top-3 left-3 bg-[#23282B]/85 text-white text-[10px] font-bold uppercase tracking-[0.2em] px-2.5 py-1 pointer-events-none">Before</span>
      <span className="absolute top-3 right-3 bg-[#2F5F80] text-white text-[10px] font-bold uppercase tracking-[0.2em] px-2.5 py-1 pointer-events-none">After</span>

      {/* divider + handle */}
      <div className="absolute inset-y-0 w-0.5 bg-white pointer-events-none" style={{ left: `${pos}%` }} />
      <div
        className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-10 h-10 bg-white text-[#2F5F80] flex items-center justify-center shadow-[0_2px_10px_rgba(0,0,0,0.4)] rounded-full pointer-events-none"
        style={{ left: `${pos}%` }}
      >
        <ChevronsLeftRight size={20} />
      </div>

      {!touched && (
        <span className="absolute bottom-3 left-1/2 -translate-x-1/2 bg-[#23282B]/85 text-white text-[10px] font-bold uppercase tracking-[0.18em] px-3 py-1.5 pointer-events-none animate-pulse whitespace-nowrap">
          Drag to see the transformation
        </span>
      )}
    </div>
  );
}
